import { render, staticRenderFns } from "./index-skeleton.vue?vue&type=template&id=31d94f91&scoped=true&"
import script from "./index-skeleton.vue?vue&type=script&lang=js&"
export * from "./index-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./index-skeleton.vue?vue&type=style&index=0&id=31d94f91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d94f91",
  null
  
)

export default component.exports